import React from "react";

import { IndividualVisionPlan, IndividualDentalPlan } from "IndividualApplication/types";
import { sum } from "lodash";
import formatCurrency from "Utils/formatCurrency";

import { SurfaceSection } from "Cobalt/Surface";
import { Table, TR, TH, TD, HeaderTR, FooterTR, FooterTD, NestedTR } from "Cobalt/TableV2";
import { Row, Col } from "Common/Grid";

const planCostBreakdownRow = (planType: string, costs: object) => {
  const { selfCost } = costs;
  const { dependentCost } = costs;
  return (
    <>
      <TR>
        <TD>{planType == "individual_dental" ? "Dental" : "Vision"}</TD>
        <TD>{formatCurrency(selfCost + (dependentCost || 0))}</TD>
      </TR>
      <NestedTR>
        <TD>Me</TD>
        <TD>{formatCurrency(selfCost)}</TD>
      </NestedTR>
      {dependentCost && (
        <NestedTR>
          <TD>Dependents</TD>
          <TD>{formatCurrency(dependentCost)}</TD>
        </NestedTR>
      )}
    </>
  );
};

export interface IndividualCostReviewTableParams {
  coverageSelected: string;
  dentalPlan: IndividualDentalPlan;
  visionPlan: IndividualVisionPlan;
}

export const IndividualCostReviewTable = ({ coverageSelected, dentalPlan, visionPlan }: IndividualCostReviewTableParams) => {
  const formatCosts = (plan) => {
    const costs = (plan?.employee_costs && plan?.employee_costs[0]) || {};
    const selfCost = costs.self_cost;
    let dependentCost;

    if (coverageSelected != "self_cost") {
      dependentCost = costs[coverageSelected] || 0;
      if (coverageSelected == "child_cost") dependentCost = sum(costs[coverageSelected]) || 0;
    }
    return { selfCost, dependentCost };
  };
  const dentalCosts = formatCosts(dentalPlan);
  const visionCosts = formatCosts(visionPlan);

  return (
    <SurfaceSection title="Review Your Cost">
      <Row>
        <Col xs={8}>
          <Table>
            <thead>
              <HeaderTR>
                <TH>Item</TH>
                <TH>Monthly Cost</TH>
              </HeaderTR>
            </thead>
            <tbody>
              {coverageSelected && (
                <>
                  {dentalPlan && planCostBreakdownRow(dentalPlan.type, dentalCosts)}
                  {visionPlan && planCostBreakdownRow(visionPlan.type, visionCosts)}
                </>
              )}
            </tbody>
            <tfoot>
              <FooterTR>
                <FooterTD>Total</FooterTD>
                <FooterTD>
                  {formatCurrency(
                    coverageSelected ? sum([dentalCosts.selfCost, visionCosts.selfCost, dentalCosts.dependentCost, visionCosts.dependentCost]) : 0,
                  )}
                </FooterTD>
              </FooterTR>
            </tfoot>
          </Table>
        </Col>
      </Row>
    </SurfaceSection>
  );
};
